import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, defineAsyncComponent } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Icon',
  props: {
  xs: Boolean,
  sm: Boolean,
  md: Boolean,
  name: {
    type: String,
    required: true
  }
},
  setup(__props) {

const props = __props;

const isProduction = process.env.NODE_ENV === 'production'
const isWebpack = process.env.BUILDER_TYPE === 'webpack' || isProduction



/* temp fix: vite dev not dont support dynamic path
  https://github.com/vitejs/vite/issues/4945
  https://vitejs.dev/guide/features.html#glob-import
*/
const sizeClasses = computed<string>(() => {
  if (props.xs) {
    return 'h-2 w-2 min-w-2'
  }

  if (props.sm) {
    return 'h-3 w-3 min-w-3'
  }

  if (props.md) {
    return 'h-4 w-4 min-w-4'
  }

  return 'h-6 w-6 min-w-6'
})

const dynamicComponent = defineAsyncComponent(() => {
  let name = props.name

  if (name.includes('ledger-legacy')) {
    name = 'wallet/ledger'
  }

  if (name.includes('ledger')) {
    name = 'wallet/ledger'
  }

  return new Promise((resolve, _reject) => {
    if (!isWebpack) {
      const comps = import.meta.glob('./../../lib/icons/**/*.vue')

      return comps[`../icons/${name}.vue`]().then((component) =>
        resolve(component.default)
      )
    }

    // webpack
    import(/* @vite-ignore */ `./../../lib/icons/${name}.vue`).then(
      (component) => resolve(component)
    )
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(dynamicComponent)), {
    class: _normalizeClass(["cursor-pointer", [_ctx.$attrs.class ? _ctx.$attrs.class : _unref(sizeClasses)]])
  }, null, 8, ["class"]))
}
}

})